<template>
  <b-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="fullPage"
    ></loading>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <b-form-select
            v-model="filter2"
            :options="select.filterOptions"
            required
            class="input-new"
            @change="resetFilter"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-input-group v-if="filter2 === '1'">
          <b-form-input
            v-model="form.outlet_name"
            type="text"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
            @click="resetIndex"
          ></b-form-input>
        </b-input-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <b-button
            variant="primary"
            class="input-new"
            v-if="filter2 !== null"
            @click="onClickSearch"
            >SEARCH</b-button
          >
          &nbsp;&nbsp;&nbsp;
          <b-button
            variant="warning"
            class="input-new"
            v-if="filter2 !== null"
            @click="clearFilter"
            >CLEAR</b-button
          >
        </b-form-group>
      </b-col>
    </b-row>
    <!-- TABLE -->

    <b-table
      show-empty
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
    >
      <template v-slot:cell(index)="data">
        {{ pagination.startIndex + data.index }}
      </template>
      <template v-slot:cell(action)="data">
        <span>
          <b-button variant="primary" size="sm" @click="onClickEdit(data.item)"
            >EDIT</b-button
          >&nbsp;&nbsp;&nbsp;
          <b-button
            variant="primary"
            size="sm"
            @click="onClickDelete(data.item.outlet_user_id)"
            >DELETE</b-button
          >
        </span>
      </template>
    </b-table>
    <b-pagination
      v-model="pagination.current"
      :total-rows="pagination.total"
      :per-page="pagination.perPage"
      @change="onChangePage"
    ></b-pagination>

    <!-- POPUP DELETE -->

    <b-modal id="modal-delete" title="Delete Confirmation">
      <p>
        <b>Are you sure you want to delete ?</b>
      </p>

      <template v-slot:modal-footer="{ close }">
        <b-button variant="primary" size="sm" @click="close()">
          CLOSE
        </b-button>
        <b-button variant="danger" size="sm" @click="onClickDeleteConfirm">
          Delete
        </b-button>
      </template>
    </b-modal>
  </b-card>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  data() {
    return {
      items: [],
      filter2: null,
      isLoading: false,
      fullPage: true,
      select: {
        filterOptions: [
          { text: "Please Select", value: null },
          { text: "Outlet Name", value: "1" }
        ]
      },
      indexsearch: 1,
      form: {
        outlet_name: null,
        page: 1
      },
      pagination: {
        total: 0,
        current: 1,
        perPage: 10,
        startIndex: 0
      }
    };
  },
  components: {
    Loading
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  mounted() {},
  created() {
    this.getOutlet();
  },
  watch: {
    refresh() {
      // if (newVal) {
        this.getOutlet();
      // }
    }
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    refresh: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClickDelete(id) {
      this.deleteIndex = id;
      this.$bvModal.show("modal-delete");
    },
    onClickDeleteConfirm() {
      const form = {
        outlet_user_id: this.deleteIndex
      };
      this.$store.dispatch("deleteOutletNameHistory", form).then(res => {
        if (res.data.response.code === 1) {
          this.$bvModal.hide("modal-delete");
          this.getOutlet();
        }
      });
    },
    getOutlet() {
      this.isLoading = true;
      this.$store
        .dispatch("getOutletNameHistory", this.pagination.current)
        .then(res => {
          if (res.data.response.code === 100) {
            this.isLoading = false;
            this.items = [];
            res.data.data.data.forEach(element => {
              this.items.push({
                outlet_name: element.outlet_name,
                outlet_user_id: element.outlet_user_id,
                faxno: element.faxno,
                telno: element.telno,
                add1: element.add1,
                add2: element.add2,
                add3: element.add3,
                notes: element.notes
              });
            });
            this.pagination.total = res.data.data.total;
            this.pagination.current = res.data.data.current_page;
            this.pagination.perPage = res.data.data.per_page;
            this.pagination.startIndex = res.data.data.from;
          }
        });
    },
    onClickEdit(index) {
      this.$emit("edit", index);
    },
    onChangePage(index) {
      this.pagination.current = index;
      if (this.filter2 === null) {
        this.getOutlet();
      } else {
        this.indexsearch =
          this.pagination.current !== this.indexsearch
            ? this.pagination.current
            : this.indexsearch++;
        this.onClickSearch();
      }
    },
    resetFilter() {
      this.form.outlet_name = null;
    },
    clearFilter() {
      this.filter2 = null;
      this.form.outlet_name = null;
      this.getOutlet();
    },
    resetIndex() {
      this.indexsearch = 1;
    },
    onClickSearch() {
      this.isLoading = true;
      this.form.page = this.indexsearch;

      if (this.filter2 === null) {
        this.getOutlet();
      } else {
        this.$store.dispatch("searchOutletNameHistory", this.form).then(res => {
          this.isLoading = false;
          this.items = [];
          res.data.data.data.forEach(element => {
            this.items.push({
              outlet_name: element.outlet_name,
              outlet_user_id: element.outlet_user_id,
              faxno: element.faxno,
              telno: element.telno,
              add1: element.add1,
              add2: element.add2,
              add3: element.add3,
              notes: element.notes
            });
          });
          this.pagination.total = res.data.data.total;
          this.pagination.current = res.data.data.current_page;
          this.pagination.perPage = res.data.data.per_page;
          this.pagination.startIndex = res.data.data.from;
          this.indexsearch = res.data.data.current_page;
        });
      }
    }
  }
};
</script>
<style lang="css" scoped></style>
